import {
  Button,
  Divider,
  Fieldset,
  Group,
  SimpleGrid,
  Text,
  TextInput,
  UnstyledButton,
} from "@mantine/core";
import { IconReload } from "@tabler/icons-react";

interface ICompanySection {
  editId: number | null;
  openCompanySearch: (type: "from" | "to") => void;
  openCompanyHistoryModal: () => void;
  fromCompany: { id: number; name: string } | null;
  toCompany: { id: number; name: string } | null;
  isEptp: boolean;
  isRegistered?: boolean;
  onClear: () => void;
}

export default function CompanySection(props: ICompanySection) {
  const {
    editId,
    openCompanySearch,
    openCompanyHistoryModal,
    fromCompany,
    toCompany,
    isEptp,
    isRegistered,
    onClear,
  } = props;

  const disabledFromCompany = isEptp || isRegistered || fromCompany !== null;
  return (
    <div>
      <Group justify="space-between">
        <Group>
          <Text fw="bold">거래처 정보 입력</Text>
          {editId && (
            <Button variant="outline" onClick={openCompanyHistoryModal}>
              변경이력
            </Button>
          )}
        </Group>
        {!editId && (
          <UnstyledButton
            onClick={onClear}
            style={{
              cursor: "pointer",
            }}
          >
            <IconReload size={16} />
            <Text size="sm" ml={4}>
              입력 초기화
            </Text>
          </UnstyledButton>
        )}
      </Group>
      <Divider my="xs" />
      <Fieldset legend="출고 거래처(From)" radius="xs" variant="filled">
        <SimpleGrid cols={2} spacing="md">
          <Group align="flex-end">
            <TextInput
              label="거래처명"
              placeholder="거래처명을 검색하세요."
              value={
                fromCompany ? `(${fromCompany.id}) ${fromCompany.name}` : ""
              }
              style={{ flex: 1 }}
              readOnly
              disabled={disabledFromCompany}
            />
            <Button
              onClick={() => openCompanySearch("from")}
              disabled={disabledFromCompany}
            >
              검색
            </Button>
          </Group>
        </SimpleGrid>
      </Fieldset>
      <Fieldset legend="입고 거래처(To)" radius="xs" variant="filled">
        <SimpleGrid cols={2} spacing="md">
          <Group align="flex-end">
            <TextInput
              label="거래처명"
              placeholder="거래처명을 검색하세요."
              value={toCompany ? `(${toCompany.id}) ${toCompany.name}` : ""}
              style={{ flex: 1 }}
              readOnly
              disabled={isRegistered}
            />
            <Button
              onClick={() => openCompanySearch("to")}
              disabled={isRegistered}
            >
              검색
            </Button>
          </Group>
        </SimpleGrid>
      </Fieldset>
    </div>
  );
}
